// @ts-nocheck
import { ProductContext } from "@insite/client-framework/Components/ProductContext";
import WidgetModule from "@insite/client-framework/Types/WidgetModule";
import WidgetProps from "@insite/client-framework/Types/WidgetProps";
import ProductPartNumbers, { ProductPartNumbersStyles } from "@store/Overrides/Components/ProductPartNumbers";
import { inlineSeparatorStyles } from "@store/Themes/common/mixins/typography";
import { attributeSpacing } from "@store/Themes/common/props/attributes";
import { spacingStyles } from "@toolkit/Themes/common/mixins";
import React, { FC, useContext } from "react";
import { css } from "styled-components";

/* Greif Custom Code - Start */
import { pxToRem } from "@toolkit/Framework/Common/Utilities/unitHelper";
/* Greif Custom Code - End */
const enum fields {
    showLabel = "showLabel",
    showManufacturingNumber = "showManufacturingNumber",
    showCustomerPartNumber = "showCustomerPartNumber",
}

interface Props extends WidgetProps {
    fields: {
        [fields.showLabel]: boolean;
        [fields.showManufacturingNumber]: boolean;
        [fields.showCustomerPartNumber]: boolean;
    };
}

interface ProductNumbersStyles {
    productPartNumbers?: ProductPartNumbersStyles;
}

const productNumbersStyle: ProductNumbersStyles = {
    productPartNumbers: {
        wrapper: {
            css: css`
                ${
                    /* Greif Custom Code - Start */
                    ({ theme }) => css`
                        ${spacingStyles(pxToRem(3), theme.design.product.detail.contentSpacing)}
                        line-height: ${theme.design.typography.lineHeight.base};
                    `
                    /* Greif Custom Code - End */
                }
                display: flex;
                flex-wrap: wrap;
                row-gap: ${attributeSpacing};
            `,
        },
        innerWrapper: {
            css: css`
                ${
                    inlineSeparatorStyles({
                        spacing: "1em",
                        width: pxToRem(1),
                        color: "text.accent",
                    }) /* Greif Custom Code */
                }
                margin-bottom: 0;
            `,
        },
        /* Greif Custom Code - Start */
        erpNumberLabelText: {
            color: "text.light",
        },
        customerNameLabelText: {
            color: "text.light",
        },
        customerNameValueText: {
            color: "text.light",
        },
        erpNumberValueText: {
            color: "text.light",
        },
        /* Greif Custom Code - End */
    },
};

const ProductDetailsPartNumbers: FC<Props> = ({
    fields: { showLabel, showManufacturingNumber, showCustomerPartNumber },
}) => {
    const { product } = useContext(ProductContext);

    return (
        <ProductPartNumbers
            productNumber={product.productNumber}
            customerProductNumber={product.customerProductNumber}
            manufacturerItem={product.manufacturerItem}
            showCustomerName={showCustomerPartNumber}
            showLabel={showLabel}
            showManufacturerItem={showManufacturingNumber}
            extendedStyles={productNumbersStyle.productPartNumbers}
        />
    );
};

const widgetModule: WidgetModule = {
    component: ProductDetailsPartNumbers,
    definition: {
        group: "Product Details",
        displayName: "Part Numbers",
        allowedContexts: ["ProductDetailsPage"],
        icon: "list-ul",
        fieldDefinitions: [
            {
                name: fields.showLabel,
                displayName: "Show Labels",
                editorTemplate: "CheckboxField",
                defaultValue: true,
                fieldType: "General",
            },
            {
                name: fields.showManufacturingNumber,
                displayName: "Show Manufacturing Part Number",
                editorTemplate: "CheckboxField",
                defaultValue: true,
                fieldType: "General",
            },
            {
                name: fields.showCustomerPartNumber,
                displayName: "Show Customer Part Number",
                editorTemplate: "CheckboxField",
                defaultValue: true,
                fieldType: "General",
            },
        ],
    },
};

export default widgetModule;
